import { render, staticRenderFns } from "./SosSelect.vue?vue&type=template&id=62972aae&lang=pug"
import script from "./SosSelect.vue?vue&type=script&lang=js"
export * from "./SosSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports